export const pageConfiguracoes = (screen) => {
   return `Configurações - ${screen} `
}
